import { Reveal, SectionHead } from "@/components/bits/Reveal";

const MOMENTS = [
  { img: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?q=80&w=1200&auto=format&fit=crop", caption: "Campus Orientation", sub: "Pre-program briefing with student batches", tall: false },
  { img: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?q=80&w=1200&auto=format&fit=crop", caption: "Technical Workshops", sub: "Skill sessions ahead of industrial programs", tall: true },
  { img: "https://images.unsplash.com/photo-1577896851231-70ef18881754?q=80&w=1200&auto=format&fit=crop", caption: "Classroom to Career", sub: "Career awareness sessions with faculty", tall: false },
  { img: "https://images.unsplash.com/photo-1581092160607-ee22621dd758?q=80&w=1200&auto=format&fit=crop", caption: "Lab & Shopfloor Exposure", sub: "Hands-on understanding of real equipment", tall: true },
  { img: "https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=1200&auto=format&fit=crop", caption: "Drive Coordination", sub: "Structured recruitment drive planning", tall: false },
  { img: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=1200&auto=format&fit=crop", caption: "Institution Partnerships", sub: "Working with campuses across the region", tall: false },
];

export default function DriveGallery() {
  return (
    <section className="bg-white py-16 sm:py-24" data-testid="drive-gallery">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <SectionHead
          overline="On the Ground"
          title={["Drives, batches and", "campus moments."]}
          description="A look at the formats we coordinate with institutions — orientations, workshops, recruitment drives and shopfloor exposure programs."
        />
        <div className="mt-14 columns-1 sm:columns-2 lg:columns-3 gap-5 space-y-5">
          {MOMENTS.map((m, i) => (
            <Reveal key={m.caption} delay={(i % 3) * 0.08} className="break-inside-avoid">
              <figure
                className="group relative overflow-hidden rounded-sm border border-ink/8 hover:border-gold/50 transition-colors duration-500"
                data-testid={`gallery-${i}`}
              >
                <img
                  src={m.img}
                  alt={m.caption}
                  loading="lazy"
                  className={`w-full object-cover grayscale-[30%] group-hover:grayscale-0 group-hover:scale-[1.04] transition-all duration-700 ${m.tall ? "h-96" : "h-64"}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-darknavy/85 via-transparent to-transparent" />
                <figcaption className="absolute bottom-0 left-0 right-0 p-5">
                  <div className="h-px w-10 bg-gold mb-3 group-hover:w-16 transition-all duration-500" />
                  <p className="font-display text-lg text-white">{m.caption}</p>
                  <p className="text-xs text-white/60 mt-1">{m.sub}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.2}>
          <p className="text-xs text-muted mt-8 text-center max-w-xl mx-auto">
            Imagery above is representative of our program formats. Photography from Maqline-coordinated
            drives and training batches is featured here as programs are documented.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
